import React, { useState } from 'react';
import { MenuItems } from './MenuItems';
import { hasChildren } from './Menuutils';
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { Link } from 'react-router-dom';
import { Tooltip } from '@mui/material';


export default function MenuBar() {
    return MenuItems.map((item, key) => <MenuItem key={key} item={item} />);
  }

  const MenuItem = ({ item }) => {
    const MenuComponent = hasChildren(item) ? MultiLevel : SingleLevel;
    return <MenuComponent item={item} />;
  };
  
  const SingleLevel = ({ item }) => {
    return (
      <ListItem
        button
        component={Link}
        to={item.to}
      >
        <ListItemIcon 
                      className="text-white"
                      sx={{
                        minWidth: 0,
                        // mr: open ? 2 : "auto",
                        justifyContent: "center",
                      }}
                      
                      >
                {item.icon}
        </ListItemIcon>
        <Tooltip title={item.title}><ListItemText className="text-white sidebar-link" primary={item.title}  /></Tooltip>
      </ListItem>
    );
  };
  
  const MultiLevel = ({ item }) => {
  
    const { items: children } = item;
    const [open, setOpen] = useState(false);
  
    const handleClick = () => {
      setOpen((prev) => !prev);
    };
  
    return (
      <React.Fragment>
        <ListItem button component={Link} to={item.to} onClick={handleClick}>
          <ListItemIcon  
                     className="text-white"
                      sx={{
                        minWidth: 0,
                        mr: open ? 2 : "auto",
                        justifyContent: "center",
                      }}>
                    {item.icon}
            </ListItemIcon>
          <ListItemText  className="text-white sidebar-link" primary={item.title} sx={{ opacity: open ? 1 : 1 }} />
          {open ? <ExpandLess style={{color : "white" }} /> : <ExpandMore style={{color : "white" }} />}
        </ListItem>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {children.map((child, key) => (
              <MenuItem key={key} item={child} />
            ))}
          </List>
        </Collapse>
      </React.Fragment>
    );
  };
  